import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

export interface ToggleExpandButtonProps {
  className?: string;
  isExpanded: boolean;
  onChange: (newIsExpanded: boolean) => void;
}

/*
 * A simple button with an icon reflecting its current state of being expanded or collapsed.
 *
 * @storybook https://dev--622a4c57262ed1003a5a57fa.chromatic.com/?path=/story/buttons-toggleexpandbutton--basic
 */

export default function ToggleExpandButton({
  className,
  isExpanded,
  onChange,
}: ToggleExpandButtonProps): JSX.Element {
  function handleClick(): void {
    onChange(!isExpanded);
  }

  return (
    <Tooltip text={isExpanded ? 'Collapse' : 'Expand'}>
      <Button
        className={className}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon={isExpanded ? 'collapse-right-full' : 'expand-right-full'}
        onClick={handleClick}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}
